import $ from 'jquery';
import React, { useEffect } from 'react';

const Menu = () => {
    useEffect(() => {
        // Tab
        $('.foodmenu_tab_button_group > li > a').eq(0).addClass("selected");
        $('.foodmenu_tab_container > .foodmenu_tab_info').eq(0).css({ 'display': 'block' });
        $('.foodmenu_tab_button_group').on("click", function (e) {
            if ($(e.target).is("a")) {

                /*Handle Tab Nav*/
                $('.foodmenu_tab_button_group > li > a').removeClass("selected");
                $(e.target).addClass("selected");

                /*Handles Tab Content*/
                var clicked_index = $("a", this).index(e.target);
                $('.foodmenu_tab_container > .foodmenu_tab_info').css({ 'display': 'none' });
                $('.foodmenu_tab_container > .foodmenu_tab_info').eq(clicked_index).fadeIn();

            }
            $(this).blur();
            return false;
        });
    }, []);
    return (
        <div className="section_sm bg_image_7">
            <div className="container">
                <div className="section_header">
                    <img src="images/title_back.png" alt="" />
                    <h2 className="section_title">Restaurant Menu</h2>
                    <h6 className="section_sub_title">Find your favourite meal from the delicious options we have</h6>
                </div>

                <div className="foodmenu_tab">
                    <ul className="foodmenu_tab_button_group">
                        <li className="foodmenu_tab_button">
                            <a className="selected">
                                <div className="tabicon">
                                    <img className="primary" src="images/menu/tabicon_1_1.png" alt="" />
                                    <img className="secondary" src="images/menu/tabicon_1_2.png" alt="" />
                                </div>
                                Main Course
                            </a>
                        </li>
                        <li className="foodmenu_tab_button">
                            <a>
                                <div className="tabicon">
                                    <img className="primary" src="images/menu/tabicon_2_1.png" alt="" />
                                    <img className="secondary" src="images/menu/tabicon_2_2.png" alt="" />
                                </div>
                                Steaks
                            </a>
                        </li>
                        <li className="foodmenu_tab_button">
                            <a>
                                <div className="tabicon">
                                    <img className="primary" src="images/menu/tabicon_3_1.png" alt="" />
                                    <img className="secondary" src="images/menu/tabicon_3_2.png" alt="" />
                                </div>
                                Snacks
                            </a>
                        </li>
                        <li className="foodmenu_tab_button">
                            <a>
                                <div className="tabicon">
                                    <img className="primary" src="images/menu/tabicon_4_1.png" alt="" />
                                    <img className="secondary" src="images/menu/tabicon_4_2.png" alt="" />
                                </div>
                                Desserts
                            </a>
                        </li>
                        <li className="foodmenu_tab_button">
                            <a>
                                <div className="tabicon">
                                    <img className="primary" src="images/menu/tabicon_5_1.png" alt="" />
                                    <img className="secondary" src="images/menu/tabicon_5_2.png" alt="" />
                                </div>
                                Drinks
                            </a>
                        </li>
                    </ul>

                    <div className="foodmenu_tab_container">
                        <div className="foodmenu_tab_info selected">
                            <div className="row">
                                <div className="col-lg-6 col-md-6">
                                    <div className="foodmenu_tab_content">
                                        <div className="menu_serial">01.</div>
                                        <div className="menu_item">
                                            <div className="menu_item_inner">
                                                <div className="name">Chicken Avocado Sandwitch</div>
                                                <div className="line"></div>
                                                <div className="price">$ 220</div>
                                            </div>
                                            <p>Lorem ipsum dolor sit amet consecturer duis</p>
                                        </div>
                                    </div>

                                    <div className="foodmenu_tab_content">
                                        <div className="menu_serial">02.</div>
                                        <div className="menu_item">
                                            <div className="menu_item_inner">
                                                <div className="name">Banana Nut Pancakes</div>
                                                <div className="line"></div>
                                                <div className="price">$ 180</div>
                                            </div>
                                            <p>Lorem ipsum dolor sit amet consecturer duis</p>
                                        </div>
                                    </div>

                                    <div className="foodmenu_tab_content">
                                        <div className="menu_serial">03.</div>
                                        <div className="menu_item">
                                            <div className="menu_item_inner">
                                                <div className="name">Swiss Hash Browns</div>
                                                <div className="line"></div>
                                                <div className="price">$ 110</div>
                                            </div>
                                            <p>Lorem ipsum dolor sit amet consecturer duis</p>
                                        </div>
                                    </div>

                                    <div className="foodmenu_tab_content">
                                        <div className="menu_serial">04.</div>
                                        <div className="menu_item">
                                            <div className="menu_item_inner">
                                                <div className="name">Perfect Scrambled Eggs</div>
                                                <div className="line"></div>
                                                <div className="price">$ 150</div>
                                            </div>
                                            <p>Lorem ipsum dolor sit amet consecturer duis</p>
                                        </div>
                                    </div>

                                    <div className="foodmenu_tab_content">
                                        <div className="menu_serial">05.</div>
                                        <div className="menu_item">
                                            <div className="menu_item_inner">
                                                <div className="name">Sesame Noodles with Garlic</div>
                                                <div className="line"></div>
                                                <div className="price">$ 130</div>
                                            </div>
                                            <p>Lorem ipsum dolor sit amet consecturer duis</p>
                                        </div>
                                    </div>

                                    <div className="foodmenu_tab_content">
                                        <div className="menu_serial">06.</div>
                                        <div className="menu_item">
                                            <div className="menu_item_inner">
                                                <div className="name">Beer-Cheeseburger</div>
                                                <div className="line"></div>
                                                <div className="price">$ 154</div>
                                            </div>
                                            <p>Lorem ipsum dolor sit amet consecturer duis</p>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-lg-6 col-md-6">
                                    <div className="foodmenu_tab_content">
                                        <div className="menu_serial">07.</div>
                                        <div className="menu_item">
                                            <div className="menu_item_inner">
                                                <div className="name">Spaghetti carbonara</div>
                                                <div className="line"></div>
                                                <div className="price">$ 220</div>
                                            </div>
                                            <p>Lorem ipsum dolor sit amet consecturer duis</p>
                                        </div>
                                    </div>

                                    <div className="foodmenu_tab_content">
                                        <div className="menu_serial">08.</div>
                                        <div className="menu_item">
                                            <div className="menu_item_inner">
                                                <div className="name">Grilled Cheese Crostini</div>
                                                <div className="line"></div>
                                                <div className="price">$ 180</div>
                                            </div>
                                            <p>Lorem ipsum dolor sit amet consecturer duis</p>
                                        </div>
                                    </div>

                                    <div className="foodmenu_tab_content">
                                        <div className="menu_serial">09.</div>
                                        <div className="menu_item">
                                            <div className="menu_item_inner">
                                                <div className="name">Chicken Avocado Sandwitch</div>
                                                <div className="line"></div>
                                                <div className="price">$ 110</div>
                                            </div>
                                            <p>Lorem ipsum dolor sit amet consecturer duis</p>
                                        </div>
                                    </div>

                                    <div className="foodmenu_tab_content">
                                        <div className="menu_serial">10.</div>
                                        <div className="menu_item">
                                            <div className="menu_item_inner">
                                                <div className="name">Roasted Veggie Chips</div>
                                                <div className="line"></div>
                                                <div className="price">$ 150</div>
                                            </div>
                                            <p>Lorem ipsum dolor sit amet consecturer duis</p>
                                        </div>
                                    </div>

                                    <div className="foodmenu_tab_content">
                                        <div className="menu_serial">11.</div>
                                        <div className="menu_item">
                                            <div className="menu_item_inner">
                                                <div className="name">One-Pot Beef with Broccoli</div>
                                                <div className="line"></div>
                                                <div className="price">$ 130</div>
                                            </div>
                                            <p>Lorem ipsum dolor sit amet consecturer duis</p>
                                        </div>
                                    </div>

                                    <div className="foodmenu_tab_content">
                                        <div className="menu_serial">12.</div>
                                        <div className="menu_item">
                                            <div className="menu_item_inner">
                                                <div className="name">Pesto Chicken Bake</div>
                                                <div className="line"></div>
                                                <div className="price">$ 154</div>
                                            </div>
                                            <p>Lorem ipsum dolor sit amet consecturer duis</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="foodmenu_tab_info">
                            <div className="row">
                                <div className="col-lg-6 col-md-6">
                                    <div className="foodmenu_tab_content">
                                        <div className="menu_serial">01.</div>
                                        <div className="menu_item">
                                            <div className="menu_item_inner">
                                                <div className="name">Banana Nut Pancakes</div>
                                                <div className="line"></div>
                                                <div className="price">$ 180</div>
                                            </div>
                                            <p>Lorem ipsum dolor sit amet consecturer duis</p>
                                        </div>
                                    </div>

                                    <div className="foodmenu_tab_content">
                                        <div className="menu_serial">02.</div>
                                        <div className="menu_item">
                                            <div className="menu_item_inner">
                                                <div className="name">Chicken Avocado Sandwitch</div>
                                                <div className="line"></div>
                                                <div className="price">$ 220</div>
                                            </div>
                                            <p>Lorem ipsum dolor sit amet consecturer duis</p>
                                        </div>
                                    </div>

                                    <div className="foodmenu_tab_content">
                                        <div className="menu_serial">03.</div>
                                        <div className="menu_item">
                                            <div className="menu_item_inner">
                                                <div className="name">Swiss Hash Browns</div>
                                                <div className="line"></div>
                                                <div className="price">$ 110</div>
                                            </div>
                                            <p>Lorem ipsum dolor sit amet consecturer duis</p>
                                        </div>
                                    </div>

                                    <div className="foodmenu_tab_content">
                                        <div className="menu_serial">04.</div>
                                        <div className="menu_item">
                                            <div className="menu_item_inner">
                                                <div className="name">Perfect Scrambled Eggs</div>
                                                <div className="line"></div>
                                                <div className="price">$ 150</div>
                                            </div>
                                            <p>Lorem ipsum dolor sit amet consecturer duis</p>
                                        </div>
                                    </div>

                                    <div className="foodmenu_tab_content">
                                        <div className="menu_serial">05.</div>
                                        <div className="menu_item">
                                            <div className="menu_item_inner">
                                                <div className="name">Beer-Cheeseburger</div>
                                                <div className="line"></div>
                                                <div className="price">$ 154</div>
                                            </div>
                                            <p>Lorem ipsum dolor sit amet consecturer duis</p>
                                        </div>
                                    </div>

                                    <div className="foodmenu_tab_content">
                                        <div className="menu_serial">06.</div>
                                        <div className="menu_item">
                                            <div className="menu_item_inner">
                                                <div className="name">Sesame Noodles with Garlic</div>
                                                <div className="line"></div>
                                                <div className="price">$ 130</div>
                                            </div>
                                            <p>Lorem ipsum dolor sit amet consecturer duis</p>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-lg-6 col-md-6">
                                    <div className="foodmenu_tab_content">
                                        <div className="menu_serial">07.</div>
                                        <div className="menu_item">
                                            <div className="menu_item_inner">
                                                <div className="name">Spaghetti carbonara</div>
                                                <div className="line"></div>
                                                <div className="price">$ 220</div>
                                            </div>
                                            <p>Lorem ipsum dolor sit amet consecturer duis</p>
                                        </div>
                                    </div>

                                    <div className="foodmenu_tab_content">
                                        <div className="menu_serial">08.</div>
                                        <div className="menu_item">
                                            <div className="menu_item_inner">
                                                <div className="name">Grilled Cheese Crostini</div>
                                                <div className="line"></div>
                                                <div className="price">$ 180</div>
                                            </div>
                                            <p>Lorem ipsum dolor sit amet consecturer duis</p>
                                        </div>
                                    </div>

                                    <div className="foodmenu_tab_content">
                                        <div className="menu_serial">09.</div>
                                        <div className="menu_item">
                                            <div className="menu_item_inner">
                                                <div className="name">Chicken Avocado Sandwitch</div>
                                                <div className="line"></div>
                                                <div className="price">$ 110</div>
                                            </div>
                                            <p>Lorem ipsum dolor sit amet consecturer duis</p>
                                        </div>
                                    </div>

                                    <div className="foodmenu_tab_content">
                                        <div className="menu_serial">10.</div>
                                        <div className="menu_item">
                                            <div className="menu_item_inner">
                                                <div className="name">Roasted Veggie Chips</div>
                                                <div className="line"></div>
                                                <div className="price">$ 150</div>
                                            </div>
                                            <p>Lorem ipsum dolor sit amet consecturer duis</p>
                                        </div>
                                    </div>

                                    <div className="foodmenu_tab_content">
                                        <div className="menu_serial">11.</div>
                                        <div className="menu_item">
                                            <div className="menu_item_inner">
                                                <div className="name">One-Pot Beef with Broccoli</div>
                                                <div className="line"></div>
                                                <div className="price">$ 130</div>
                                            </div>
                                            <p>Lorem ipsum dolor sit amet consecturer duis</p>
                                        </div>
                                    </div>

                                    <div className="foodmenu_tab_content">
                                        <div className="menu_serial">12.</div>
                                        <div className="menu_item">
                                            <div className="menu_item_inner">
                                                <div className="name">Pesto Chicken Bake</div>
                                                <div className="line"></div>
                                                <div className="price">$ 154</div>
                                            </div>
                                            <p>Lorem ipsum dolor sit amet consecturer duis</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="foodmenu_tab_info">
                            <div className="row">
                                <div className="col-lg-6 col-md-6">
                                    <div className="foodmenu_tab_content">
                                        <div className="menu_serial">01</div>
                                        <div className="menu_item">
                                            <div className="menu_item_inner">
                                                <div className="name">Chicken Avocado Sandwitch</div>
                                                <div className="line"></div>
                                                <div className="price">$ 220</div>
                                            </div>
                                            <p>Lorem ipsum dolor sit amet consecturer duis</p>
                                        </div>
                                    </div>

                                    <div className="foodmenu_tab_content">
                                        <div className="menu_serial">02.</div>
                                        <div className="menu_item">
                                            <div className="menu_item_inner">
                                                <div className="name">Banana Nut Pancakes</div>
                                                <div className="line"></div>
                                                <div className="price">$ 180</div>
                                            </div>
                                            <p>Lorem ipsum dolor sit amet consecturer duis</p>
                                        </div>
                                    </div>

                                    <div className="foodmenu_tab_content">
                                        <div className="menu_serial">03.</div>
                                        <div className="menu_item">
                                            <div className="menu_item_inner">
                                                <div className="name">Swiss Hash Browns</div>
                                                <div className="line"></div>
                                                <div className="price">$ 110</div>
                                            </div>
                                            <p>Lorem ipsum dolor sit amet consecturer duis</p>
                                        </div>
                                    </div>

                                    <div className="foodmenu_tab_content">
                                        <div className="menu_serial">04.</div>
                                        <div className="menu_item">
                                            <div className="menu_item_inner">
                                                <div className="name">Perfect Scrambled Eggs</div>
                                                <div className="line"></div>
                                                <div className="price">$ 150</div>
                                            </div>
                                            <p>Lorem ipsum dolor sit amet consecturer duis</p>
                                        </div>
                                    </div>

                                    <div className="foodmenu_tab_content">
                                        <div className="menu_serial">05.</div>
                                        <div className="menu_item">
                                            <div className="menu_item_inner">
                                                <div className="name">Sesame Noodles with Garlic</div>
                                                <div className="line"></div>
                                                <div className="price">$ 130</div>
                                            </div>
                                            <p>Lorem ipsum dolor sit amet consecturer duis</p>
                                        </div>
                                    </div>

                                    <div className="foodmenu_tab_content">
                                        <div className="menu_serial">06.</div>
                                        <div className="menu_item">
                                            <div className="menu_item_inner">
                                                <div className="name">Beer-Cheeseburger</div>
                                                <div className="line"></div>
                                                <div className="price">$ 154</div>
                                            </div>
                                            <p>Lorem ipsum dolor sit amet consecturer duis</p>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-lg-6 col-md-6">
                                    <div className="foodmenu_tab_content">
                                        <div className="menu_serial">07.</div>
                                        <div className="menu_item">
                                            <div className="menu_item_inner">
                                                <div className="name">Grilled Cheese Crostini</div>
                                                <div className="line"></div>
                                                <div className="price">$ 180</div>
                                            </div>
                                            <p>Lorem ipsum dolor sit amet consecturer duis</p>
                                        </div>
                                    </div>

                                    <div className="foodmenu_tab_content">
                                        <div className="menu_serial">08.</div>
                                        <div className="menu_item">
                                            <div className="menu_item_inner">
                                                <div className="name">Spaghetti carbonara</div>
                                                <div className="line"></div>
                                                <div className="price">$ 220</div>
                                            </div>
                                            <p>Lorem ipsum dolor sit amet consecturer duis</p>
                                        </div>
                                    </div>

                                    <div className="foodmenu_tab_content">
                                        <div className="menu_serial">09.</div>
                                        <div className="menu_item">
                                            <div className="menu_item_inner">
                                                <div className="name">Chicken Avocado Sandwitch</div>
                                                <div className="line"></div>
                                                <div className="price">$ 110</div>
                                            </div>
                                            <p>Lorem ipsum dolor sit amet consecturer duis</p>
                                        </div>
                                    </div>

                                    <div className="foodmenu_tab_content">
                                        <div className="menu_serial">10.</div>
                                        <div className="menu_item">
                                            <div className="menu_item_inner">
                                                <div className="name">Roasted Veggie Chips</div>
                                                <div className="line"></div>
                                                <div className="price">$ 150</div>
                                            </div>
                                            <p>Lorem ipsum dolor sit amet consecturer duis</p>
                                        </div>
                                    </div>

                                    <div className="foodmenu_tab_content">
                                        <div className="menu_serial">11.</div>
                                        <div className="menu_item">
                                            <div className="menu_item_inner">
                                                <div className="name">One-Pot Beef with Broccoli</div>
                                                <div className="line"></div>
                                                <div className="price">$ 130</div>
                                            </div>
                                            <p>Lorem ipsum dolor sit amet consecturer duis</p>
                                        </div>
                                    </div>

                                    <div className="foodmenu_tab_content">
                                        <div className="menu_serial">12.</div>
                                        <div className="menu_item">
                                            <div className="menu_item_inner">
                                                <div className="name">Pesto Chicken Bake</div>
                                                <div className="line"></div>
                                                <div className="price">$ 154</div>
                                            </div>
                                            <p>Lorem ipsum dolor sit amet consecturer duis</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="foodmenu_tab_info">
                            <div className="row">
                                <div className="col-lg-6 col-md-6">
                                    <div className="foodmenu_tab_content">
                                        <div className="menu_serial">01</div>
                                        <div className="menu_item">
                                            <div className="menu_item_inner">
                                                <div className="name">Perfect Scrambled Eggs</div>
                                                <div className="line"></div>
                                                <div className="price">$ 150</div>
                                            </div>
                                            <p>Lorem ipsum dolor sit amet consecturer duis</p>
                                        </div>
                                    </div>

                                    <div className="foodmenu_tab_content">
                                        <div className="menu_serial">02.</div>
                                        <div className="menu_item">
                                            <div className="menu_item_inner">
                                                <div className="name">Banana Nut Pancakes</div>
                                                <div className="line"></div>
                                                <div className="price">$ 180</div>
                                            </div>
                                            <p>Lorem ipsum dolor sit amet consecturer duis</p>
                                        </div>
                                    </div>

                                    <div className="foodmenu_tab_content">
                                        <div className="menu_serial">03.</div>
                                        <div className="menu_item">
                                            <div className="menu_item_inner">
                                                <div className="name">Swiss Hash Browns</div>
                                                <div className="line"></div>
                                                <div className="price">$ 110</div>
                                            </div>
                                            <p>Lorem ipsum dolor sit amet consecturer duis</p>
                                        </div>
                                    </div>

                                    <div className="foodmenu_tab_content">
                                        <div className="menu_serial">04.</div>
                                        <div className="menu_item">
                                            <div className="menu_item_inner">
                                                <div className="name">Chicken Avocado Sandwitch</div>
                                                <div className="line"></div>
                                                <div className="price">$ 220</div>
                                            </div>
                                            <p>Lorem ipsum dolor sit amet consecturer duis</p>
                                        </div>
                                    </div>

                                    <div className="foodmenu_tab_content">
                                        <div className="menu_serial">05.</div>
                                        <div className="menu_item">
                                            <div className="menu_item_inner">
                                                <div className="name">Sesame Noodles with Garlic</div>
                                                <div className="line"></div>
                                                <div className="price">$ 130</div>
                                            </div>
                                            <p>Lorem ipsum dolor sit amet consecturer duis</p>
                                        </div>
                                    </div>

                                    <div className="foodmenu_tab_content">
                                        <div className="menu_serial">06.</div>
                                        <div className="menu_item">
                                            <div className="menu_item_inner">
                                                <div className="name">Beer-Cheeseburger</div>
                                                <div className="line"></div>
                                                <div className="price">$ 154</div>
                                            </div>
                                            <p>Lorem ipsum dolor sit amet consecturer duis</p>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-lg-6 col-md-6">
                                    <div className="foodmenu_tab_content">
                                        <div className="menu_serial">07.</div>
                                        <div className="menu_item">
                                            <div className="menu_item_inner">
                                                <div className="name">Spaghetti carbonara</div>
                                                <div className="line"></div>
                                                <div className="price">$ 220</div>
                                            </div>
                                            <p>Lorem ipsum dolor sit amet consecturer duis</p>
                                        </div>
                                    </div>

                                    <div className="foodmenu_tab_content">
                                        <div className="menu_serial">08.</div>
                                        <div className="menu_item">
                                            <div className="menu_item_inner">
                                                <div className="name">Grilled Cheese Crostini</div>
                                                <div className="line"></div>
                                                <div className="price">$ 180</div>
                                            </div>
                                            <p>Lorem ipsum dolor sit amet consecturer duis</p>
                                        </div>
                                    </div>

                                    <div className="foodmenu_tab_content">
                                        <div className="menu_serial">09.</div>
                                        <div className="menu_item">
                                            <div className="menu_item_inner">
                                                <div className="name">Chicken Avocado Sandwitch</div>
                                                <div className="line"></div>
                                                <div className="price">$ 110</div>
                                            </div>
                                            <p>Lorem ipsum dolor sit amet consecturer duis</p>
                                        </div>
                                    </div>

                                    <div className="foodmenu_tab_content">
                                        <div className="menu_serial">10.</div>
                                        <div className="menu_item">
                                            <div className="menu_item_inner">
                                                <div className="name">Roasted Veggie Chips</div>
                                                <div className="line"></div>
                                                <div className="price">$ 150</div>
                                            </div>
                                            <p>Lorem ipsum dolor sit amet consecturer duis</p>
                                        </div>
                                    </div>

                                    <div className="foodmenu_tab_content">
                                        <div className="menu_serial">11.</div>
                                        <div className="menu_item">
                                            <div className="menu_item_inner">
                                                <div className="name">One-Pot Beef with Broccoli</div>
                                                <div className="line"></div>
                                                <div className="price">$ 130</div>
                                            </div>
                                            <p>Lorem ipsum dolor sit amet consecturer duis</p>
                                        </div>
                                    </div>

                                    <div className="foodmenu_tab_content">
                                        <div className="menu_serial">12.</div>
                                        <div className="menu_item">
                                            <div className="menu_item_inner">
                                                <div className="name">Pesto Chicken Bake</div>
                                                <div className="line"></div>
                                                <div className="price">$ 154</div>
                                            </div>
                                            <p>Lorem ipsum dolor sit amet consecturer duis</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="foodmenu_tab_info">
                            <div className="row">
                                <div className="col-lg-6 col-md-6">
                                    <div className="foodmenu_tab_content">
                                        <div className="menu_serial">01</div>
                                        <div className="menu_item">
                                            <div className="menu_item_inner">
                                                <div className="name">Chicken Avocado Sandwitch</div>
                                                <div className="line"></div>
                                                <div className="price">$ 220</div>
                                            </div>
                                            <p>Lorem ipsum dolor sit amet consecturer duis</p>
                                        </div>
                                    </div>

                                    <div className="foodmenu_tab_content">
                                        <div className="menu_serial">02.</div>
                                        <div className="menu_item">
                                            <div className="menu_item_inner">
                                                <div className="name">Banana Nut Pancakes</div>
                                                <div className="line"></div>
                                                <div className="price">$ 180</div>
                                            </div>
                                            <p>Lorem ipsum dolor sit amet consecturer duis</p>
                                        </div>
                                    </div>

                                    <div className="foodmenu_tab_content">
                                        <div className="menu_serial">03.</div>
                                        <div className="menu_item">
                                            <div className="menu_item_inner">
                                                <div className="name">Swiss Hash Browns</div>
                                                <div className="line"></div>
                                                <div className="price">$ 110</div>
                                            </div>
                                            <p>Lorem ipsum dolor sit amet consecturer duis</p>
                                        </div>
                                    </div>

                                    <div className="foodmenu_tab_content">
                                        <div className="menu_serial">04.</div>
                                        <div className="menu_item">
                                            <div className="menu_item_inner">
                                                <div className="name">Perfect Scrambled Eggs</div>
                                                <div className="line"></div>
                                                <div className="price">$ 150</div>
                                            </div>
                                            <p>Lorem ipsum dolor sit amet consecturer duis</p>
                                        </div>
                                    </div>

                                    <div className="foodmenu_tab_content">
                                        <div className="menu_serial">05.</div>
                                        <div className="menu_item">
                                            <div className="menu_item_inner">
                                                <div className="name">Sesame Noodles with Garlic</div>
                                                <div className="line"></div>
                                                <div className="price">$ 130</div>
                                            </div>
                                            <p>Lorem ipsum dolor sit amet consecturer duis</p>
                                        </div>
                                    </div>

                                    <div className="foodmenu_tab_content">
                                        <div className="menu_serial">06.</div>
                                        <div className="menu_item">
                                            <div className="menu_item_inner">
                                                <div className="name">Beer-Cheeseburger</div>
                                                <div className="line"></div>
                                                <div className="price">$ 154</div>
                                            </div>
                                            <p>Lorem ipsum dolor sit amet consecturer duis</p>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-lg-6 col-md-6">
                                    <div className="foodmenu_tab_content">
                                        <div className="menu_serial">07.</div>
                                        <div className="menu_item">
                                            <div className="menu_item_inner">
                                                <div className="name">Grilled Cheese Crostini</div>
                                                <div className="line"></div>
                                                <div className="price">$ 180</div>
                                            </div>
                                            <p>Lorem ipsum dolor sit amet consecturer duis</p>
                                        </div>
                                    </div>

                                    <div className="foodmenu_tab_content">
                                        <div className="menu_serial">08.</div>
                                        <div className="menu_item">
                                            <div className="menu_item_inner">
                                                <div className="name">Chicken Avocado Sandwitch</div>
                                                <div className="line"></div>
                                                <div className="price">$ 110</div>
                                            </div>
                                            <p>Lorem ipsum dolor sit amet consecturer duis</p>
                                        </div>
                                    </div>

                                    <div className="foodmenu_tab_content">
                                        <div className="menu_serial">09.</div>
                                        <div className="menu_item">
                                            <div className="menu_item_inner">
                                                <div className="name">Spaghetti carbonara</div>
                                                <div className="line"></div>
                                                <div className="price">$ 220</div>
                                            </div>
                                            <p>Lorem ipsum dolor sit amet consecturer duis</p>
                                        </div>
                                    </div>

                                    <div className="foodmenu_tab_content">
                                        <div className="menu_serial">10.</div>
                                        <div className="menu_item">
                                            <div className="menu_item_inner">
                                                <div className="name">Roasted Veggie Chips</div>
                                                <div className="line"></div>
                                                <div className="price">$ 150</div>
                                            </div>
                                            <p>Lorem ipsum dolor sit amet consecturer duis</p>
                                        </div>
                                    </div>

                                    <div className="foodmenu_tab_content">
                                        <div className="menu_serial">11.</div>
                                        <div className="menu_item">
                                            <div className="menu_item_inner">
                                                <div className="name">One-Pot Beef with Broccoli</div>
                                                <div className="line"></div>
                                                <div className="price">$ 130</div>
                                            </div>
                                            <p>Lorem ipsum dolor sit amet consecturer duis</p>
                                        </div>
                                    </div>

                                    <div className="foodmenu_tab_content">
                                        <div className="menu_serial">12.</div>
                                        <div className="menu_item">
                                            <div className="menu_item_inner">
                                                <div className="name">Pesto Chicken Bake</div>
                                                <div className="line"></div>
                                                <div className="price">$ 154</div>
                                            </div>
                                            <p>Lorem ipsum dolor sit amet consecturer duis</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="grillman_imgtext light">
                    <img src="images/about/grillman.png" alt="" data-aos="fade-up" data-aos-duration="1000" />
                    <p>Hungrybuzz Restaurant</p>
                </div>
            </div>
        </div>
    );
};

export default Menu;    